import { BellFilled } from "@ant-design/icons";
import React, { FC } from "react";
import { NotificationBadge, NotificationBadgeProps } from "./notification-badge";

export const NotificationBell: FC<NotificationBadgeProps> = (props) => {
  return (
    <NotificationBadge
      {...props}
      icon={<BellFilled style={{ color: props.count > 0 ? "orange" : "white" }} />}
    ></NotificationBadge>
  );
};
